// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3-2Zo","label":"LabeledBox_label__9OH1q"};